import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DiagramScrollService {
	private lastScrollPosition: number = 0;
	getLastScrollPosition(): number {
		return this.lastScrollPosition;
	}

	setLastScrollPosition(scrollPosition: number): void {
		this.lastScrollPosition = scrollPosition;
	}
}
